export class BasicStrengthDTO {
  // 授業ID DB型(*autokeyFk)
  public class_id?: number;
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // 基礎力項目 DB型(*varchar20)
  public strength_item?: string;
  // 達成 DB型(*flg)
  public is_done?: boolean;
  // レベル DB型(INT)
  public current_level?: number;
  // スコア DB型(INT)
  public score?: number;
  // エピソード
  public episode?: string;
  // 非表示 DB型(*flg)
  public disabled?: boolean;
}
